<div class="recent-orders">
    <div class="title-buttons">
        <strong>{{'product.pricing' | translate}}</strong>
    </div>
    <div class="table-responsive">
        <table class="table table-striped" id="my-orders-table">
            <thead>
            <tr class="first last">
                <th colspan="2">{{'common.name' | translate}}</th>
                <th>{{'pricings.nicename' | translate}}</th>
                <th>{{'common.description' | translate}}</th>
                <th>
                    <button (click)="add_pricing()"
                            class="button button-submit button-md"> {{'common.add' | translate}}
                    </button>
                </th>
            </tr>
            </thead>
            <tbody *ngIf="loading">
            <tr>
                <td colspan="4" style="text-align: center">{{'common.loading' | translate}} ...</td>
            </tr>
            </tbody>
            <tbody *ngIf="!loading">
                <tr>
                    <td style="font-weight: bold;">Français</td>
                    <td style="font-weight: bold;">English</td>
                    <td colspan="2"></td>
                </tr>
            <tr *ngFor="let pricing of pricings | paginate: config ">
                <td>{{ pricing.nameFr }}</td>
                <td>{{ pricing.name }}</td>
                <td>{{ pricing.nicename }}</td>
                <td [innerHTML]="pricing.description"></td>
                <td>
                       <span class="nobr">
                           <a (click)="edit_pricing(pricing)">{{'common.edit' | translate}}</a>
                           <span class="separator"> | </span>
                           <a (click)="delete_pricing(pricing)">{{'common.delete' | translate}}</a>
                       </span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div class="toolbar" *ngIf="!loading">
        <div class="pager">
            <pagination-controls class="pages" maxSize="5" [previousLabel]="'common.previous' | translate" [nextLabel]="'common.next' | translate" autoHide="true"
                                 id="listing" (pageChange)="pageChange($event)"></pagination-controls>
        </div>
    </div>
</div>
